var map = {
	"./App": 4381,
	"./App.js": 4381,
	"./App.module.css": 6520,
	"./Footer": 442,
	"./Footer.js": 442,
	"./Header": 7016,
	"./Header.js": 7016,
	"./NavBar": 6507,
	"./NavBar.js": 6507,
	"./NavBarSafe": 2537,
	"./NavBarSafe.js": 2537,
	"./Section": 78,
	"./Section.js": 78,
	"./contact.png": 8900,
	"./history.png": 267,
	"./iot.png": 8256,
	"./iotmany.png": 4550,
	"./photography.png": 7720,
	"./portrait.gif": 9153,
	"./portrait.jpg": 8828,
	"./projectmanagement.png": 5095,
	"./web3.png": 9746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9245;